module.exports = __webpack_public_path__ + "img/h-1.6c305bab.png";